import React, { useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useJsApiLoader,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const libraries = ["places"];

const BookingRouteMap = ({ src_lat, src_lng, dest_lat, dest_lng }) => {
  const mapRef = useRef(null);
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'booking-route-map',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries,
    version: 'weekly',
  });

  const [directions, setDirections] = useState(null);
  const [mapCenter, setMapCenter] = useState(null);

  // Validate and parse coordinates
  const parseCoordinate = (value) => {
    const parsed = parseFloat(value);
    return !isNaN(parsed) && isFinite(parsed) ? parsed : null;
  };

  useEffect(() => {
    const srcLat = parseCoordinate(src_lat);
    const srcLng = parseCoordinate(src_lng);
    const destLat = parseCoordinate(dest_lat);
    const destLng = parseCoordinate(dest_lng);

    if (srcLat !== null && srcLng !== null) {
      setMapCenter({ lat: srcLat, lng: srcLng });
    } else if (destLat !== null && destLng !== null) {
      setMapCenter({ lat: destLat, lng: destLng });
    }

    if (!isLoaded || !window.google || !window.google.maps || !srcLat || !srcLng || !destLat || !destLng) {
      return;
    }

    try {
    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
          origin: { lat: srcLat, lng: srcLng },
          destination: { lat: destLat, lng: destLng },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirections(result);
        } else {
            console.error("Directions request failed:", status);
          }
        }
      );
    } catch (error) {
      console.error("Error loading directions:", error);
      }
  }, [isLoaded, src_lat, src_lng, dest_lat, dest_lng]);

  if (loadError) {
    return <div className="text-danger">Error loading Google Maps: {loadError.message}</div>;
  }

  if (!isLoaded) {
    return <div>Loading Map...</div>;
  }

  const srcLat = parseCoordinate(src_lat);
  const srcLng = parseCoordinate(src_lng);
  const destLat = parseCoordinate(dest_lat);
  const destLng = parseCoordinate(dest_lng);

  if (!srcLat || !srcLng || !destLat || !destLng) {
    return <div className="text-muted">Invalid coordinates provided</div>;
  }

  if (!mapCenter) {
    return <div>Loading Map...</div>;
  }

  return (
    <div ref={mapRef}>
    <GoogleMap
      mapContainerStyle={containerStyle}
        center={mapCenter}
      zoom={13}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
        }}
    >
        <Marker position={{ lat: srcLat, lng: srcLng }} label="P" />
        <Marker position={{ lat: destLat, lng: destLng }} label="D" />
        {directions && <DirectionsRenderer directions={directions} />}
    </GoogleMap>
    </div>
  );
};

export default BookingRouteMap;
